/* unplugin-vue-components disabled */import { render } from "./display.vue?vue&type=template&id=73d12c58&scoped=true"
import script from "./display.vue?vue&type=script&lang=js"
export * from "./display.vue?vue&type=script&lang=js"

import "./display.vue?vue&type=style&index=0&id=73d12c58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d12c58"]])

export default __exports__